import React, { Component } from "react";
import DocumentsForm from "./DocumentsForm/DocumentsForm";
import "filepond/dist/filepond.min.css";
import classes from "./Document.module.css";
import axiosInstance from "../../../axios-project";
import { Button } from "rsuite";
import swal from "sweetalert";
import {Modal, ModalBody, ModalHeader} from "reactstrap";

class AgencyDocuments extends Component {
  componentDidMount() {
    this.props.getAgencyDocuments(this.props.currentAgencyID);
    // console.log("agency document", this.props.documents);
  }
  delete = fild_id => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, this operation cannot be undone!",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        axiosInstance.delete("/agency_file/" + fild_id).then(response => {
          this.props.getAgencyDocuments(this.props.currentAgencyID);
        });
      }
    });
  };
  render() {
    const uploadPage = type => {
      // console.log(type);
      if (type === "picture") {
        return (
          <div className={classes.Document}>
            <h1>Logo</h1>
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Year</th>
                  <th>Description</th>
                  <th>Upload Time</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {/*todo: change this part when new findFileByID api is ready.*/}
                {this.props.documents
                  .filter(
                    document => document.file_type.toString() === "picture"
                  )
                  .map(document => (
                    <tr key={document.upload_tstamp}>
                      <td>{document.file_name}</td>
                      <td>{document.file_type}</td>
                      <td>{document.year}</td>
                      <td>{document.file_description}</td>
                      <td>
                        {document.upload_tstamp
                          .substring(5, 10)
                          .replace("-", "/") +
                          "/" +
                          document.upload_tstamp.substring(0, 4)}
                      </td>
                      <td>
                        <Button color="blue" href={document.file_url}>
                          Download
                        </Button>{" "}
                          {this.props.disabled ? null : (
                              <Button
                                  onClick={() => this.delete(document.file_id)}
                                  color="red"
                              >
                                  Delete
                              </Button>
                          )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
              <div className="modal-container">
                  <Modal
                      isOpen={this.props.showSmallModal}
                      fade
                      size="lg"
                      toggle={this.props.toggleSmallModalHandler}
                      backdrop="static"
                  >
                      <ModalHeader toggle={this.props.close}>Add Picture</ModalHeader>
                      <ModalBody>
                          <DocumentsForm
                              key={1}
                              type={"picture"}
                              addDocuments={this.props.addDocuments}
                              agencyID={this.props.currentAgencyID}
                              close={this.props.close}
                          />
                      </ModalBody>
                  </Modal>
              </div>
          </div>
        );
      } else if (type === "video") {
        return (
          <div className={classes.Document}>
            <h1>Videos</h1>
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Year</th>
                  <th>Description</th>
                  <th>Upload Time</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {/*todo: change this part when new findFileByID api is ready.*/}
                {this.props.documents
                  ? this.props.documents
                      .filter(document => document.file_type === "video")
                      .map(document => (
                        <tr key={document.upload_tstamp}>
                          <td>{document.file_name}</td>
                          <td>{document.file_type}</td>

                          <td>{document.year}</td>
                          <td>{document.file_description}</td>
                          <td>
                            {document.upload_tstamp
                              .substring(5, 10)
                              .replace("-", "/") +
                              "/" +
                              document.upload_tstamp.substring(0, 4)}
                          </td>
                          <td>
                            <Button href={document.file_url} color="blue">
                              Download
                            </Button>{" "}
                              {this.props.disabled ? null : (
                                  <Button
                                      color="red"
                                      onClick={() => this.delete(document.file_id)}
                                  >
                                      Delete
                                  </Button>
                              )}
                          </td>
                        </tr>
                      ))
                  : null}
              </tbody>
            </table>
              <div className="modal-container">
                  <Modal
                      isOpen={this.props.showSmallModal}
                      fade
                      size="lg"
                      toggle={this.props.toggleSmallModalHandler}
                      backdrop="static"
                  >
                      <ModalHeader toggle={this.props.close}>Add Video</ModalHeader>
                      <ModalBody>
                          <DocumentsForm
                              key={1}
                              type={"video"}
                              addDocuments={this.props.addDocuments}
                              agencyID={this.props.currentAgencyID}
                              close={this.props.close}
                          />
                      </ModalBody>
                  </Modal>
              </div>
          </div>
        );
      } else {
        return (
          <div className={classes.Document}>
            <h1>Documents</h1>
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Year</th>
                  <th>Description</th>
                  <th>Upload Time</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {/*todo: change this part when new findFileByID api is ready.*/}
                {this.props.documents
                  .filter(
                    document =>
                      document.file_type !== "video" &&
                      document.file_type !== "picture"
                  )
                  .map(document => (
                    <tr key={document.upload_tstamp}>
                      <td>{document.file_name}</td>
                      <td>{document.file_type}</td>

                      <td>{document.year}</td>
                      <td>{document.file_description}</td>
                      <td>
                        {document.upload_tstamp
                          .substring(5, 10)
                          .replace("-", "/") +
                          "/" +
                          document.upload_tstamp.substring(0, 4)}
                      </td>

                      <td>
                        <Button href={document.file_url} color="blue">
                          Download
                        </Button>{" "}
                          {this.props.disabled ? null : (
                              <Button
                                  color="red"
                                  onClick={() => this.delete(document.file_id)}
                              >
                                  Delete
                              </Button>
                          )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className="modal-container">
                <Modal
                    isOpen={this.props.showSmallModal}
                    fade
                    size="lg"
                    toggle={this.props.toggleSmallModalHandler}
                    backdrop="static"
                >
                    <ModalHeader toggle={this.props.close}>Add File</ModalHeader>
                    <ModalBody>
                        <DocumentsForm
                            key={1}
                            type={"video"}
                            addDocuments={this.props.addDocuments}
                            agencyID={this.props.currentAgencyID}
                            close={this.props.close}
                        />
                    </ModalBody>
                </Modal>
            </div>
          </div>
        );
      }
    };
    let mainBody = [
      uploadPage("picture"),
      uploadPage("video"),
      uploadPage("others")
    ];

    return (
      <div>
        <p>
          {this.props.disabled ? null : (
              this.props.tab_id === 0 &&
              this.props.documents.find(
                document => document.file_type.toString() === "picture"
              ) ? (
                <strong style={{ fontSize: "14pt" }}>
                  Only one logo is allowed. Please delete before upload new ones.
                </strong>
              ) : (
                  <div style={{textAlign: "right"}}>
                    <Button
                      color="blue"
                      className="my-2"
                      onClick={() => {
                        this.props.open();
                      }}
                    >
                      Upload {this.props.tab_id === 0 ? "Logo" : (this.props.tab_id === 1 ? "Video": "File")}
                    </Button>
                  </div>
              )
          )}
        </p>
        {mainBody[this.props.tab_id]}
      </div>
    );
  }
}

export default AgencyDocuments;
